import { OrtPeriod } from '@types';
import { PeriodRow } from './ort-period-row';
import { EditingRow } from './ort-period-edit-row';
import { AddPeriodRow } from './ort-period-new-row';

type PeriodGroupProps = {
  label: string;
  periods: OrtPeriod[];
  isEditing: boolean;
  tempPeriod: OrtPeriod;
  onAdd: () => void;
  onDelete: (index: number) => void;
  onSave: () => void;
  onCancel: () => void;
  onTempPeriodChange: (updates: Partial<OrtPeriod>) => void;
};

export const PeriodGroup = ({
  label,
  periods,
  isEditing,
  tempPeriod,
  onAdd,
  onDelete,
  onSave,
  onCancel,
  onTempPeriodChange,
}: PeriodGroupProps) => {
  const hasPeriods = periods.length > 0;

  const handleTempPeriodUpdate = (updates: Partial<OrtPeriod>) => {
    onTempPeriodChange(updates);
  };

  return (
    <>
      {hasPeriods &&
        periods.map((period, index) => (
          <PeriodRow
            key={`${label}-${index}`}
            period={period}
            index={index}
            totalPeriods={periods.length}
            dayLabel={label}
            isEditingThisDay={isEditing}
            onDelete={onDelete}
          />
        ))}

      <EditingRow
        isEditing={isEditing}
        periodLength={periods.length}
        dayLabel={label}
        tempPeriod={tempPeriod}
        onStartTimeChange={(value) => handleTempPeriodUpdate({ startTime: value })}
        onEndTimeChange={(value) => handleTempPeriodUpdate({ endTime: value })}
        onSurchargeChange={(value) => handleTempPeriodUpdate({ surcharge: value })}
        onSave={onSave}
        onCancel={onCancel}
      />

      <AddPeriodRow showDayHeader={!hasPeriods && !isEditing} dayLabel={label} onAdd={onAdd} />
    </>
  );
};
